export default __webpack_public_path__ + "static/media/login_side_img.0cb59d94.jpg";